import { Workflow } from '@shared/store/workflow/workflow.store';

import {
  QuarterCloseChecklistPermissionList,
  QuarterCloseChecklistSection,
} from '../models/quarter-close-checklist.model';

export function isAnyWorkflowUnlockedAndHasNoPermissions(
  section: QuarterCloseChecklistSection,
  workflowList: Workflow[],
  permissionList: QuarterCloseChecklistPermissionList
): boolean {
  if (!workflowList.length) {
    return true;
  }

  const sectionKey = Object.entries(QuarterCloseChecklistSection).find(([, value]) => {
    return value === section;
  })?.[1];

  const uncompletedWorkflows = workflowList.filter((workflow) => {
    return (
      sectionKey === (workflow.section as keyof typeof QuarterCloseChecklistSection) &&
      !workflow.properties.locked
    );
  });

  const noPermissions = uncompletedWorkflows.filter((workflow) => {
    return !permissionList[workflow.permissionField];
  });

  return noPermissions.length > 0;
}
